import Subsection from "../Subsection";
import styles from "./bestPartners.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import Ticker from "@Components/Ticker";
import Image from "@Components/Image";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";
// import Constants from "../../../../locales/langConstants.json";
import { useState } from "react";

const BestPartners = ({ isDesktop = false }) => {
  const { t } = useTranslationHook();
  const { isAbove } = useResponsiveness();
  const isAboveMD = isAbove(SCREEN_SIZE.MD, false);
  const showForDesktop = isDesktop && isAboveMD;
  const [loaded, setLoaded] = useState<Set<number>>(new Set());

  const partnerLogos: any = [
    "torrens_uni.png",
    "bimm_uni.png",
    "Niagara_uni.png",
    "westminster_uni.png",
    "schiller_uni.png",
    "uws_uni.png",
    "law_uni.png",
    "into_uni.png",
    "ue_uni.png",
    "jamescook_uni.png",
    "birmingham_uni.png",
    "lc_uni.png",
    "medicine_uni.png",
  ];

  const handleImageLoad = (index: number) => {
    setLoaded((prev) => new Set(prev).add(index));
  };

  partnerLogos.forEach((_l: any, index: any, arr: any) => {
    const isLoaded = loaded?.has(index);
    partnerLogos[index] = (
      <Image
        key={index}
        src={`https://prod-static-assets.amberstudent.com/images/partner-logos/${arr[index]}`}
        alt={arr[index]}
        width="120px"
        height="auto"
        className={styles.logo}
        addShimmer={!isLoaded}
        onLoad={() => handleImageLoad(index)}
        isAutoScroll
        autoScrollIndex={index}
      />
    );
  });

  return (
    <>
      <Subsection greyBg title={t("home.bestpartners.partnerstitle")} isDesktop={showForDesktop}>
        <Ticker items={partnerLogos} />
      </Subsection>
    </>
  );
};

export default wrapperHOC(BestPartners, {
  componentName: "BestPartners-Home",
  showForChina: true,
});
